jQuery(document).ready(() => {

	const bton_dropdown = jQuery(`[data-yearsyela="dropdown"]`);
	const icon = bton_dropdown.children('.icon');
	const bton_dropdown_text = bton_dropdown.children('.year');
	const years = bton_dropdown.siblings('.years-yela__box-years');
	const years_year = years.children();
	let year_active = years.children('.active');
	let year_active_text = year_active.children('.year__number').text();

	bton_dropdown_text.text(year_active_text);

	showBoxs();

	bton_dropdown.click(function () {

		years.slideToggle();

		if (icon.hasClass('icon-icon-chevron-down')) {
			icon.removeClass('icon-icon-chevron-down');
			icon.addClass('icon-icon-chevron-up');
		} else {
			icon.addClass('icon-icon-chevron-down');
			icon.removeClass('icon-icon-chevron-up');
		}

	});

	jQuery.each(years_year, function () {

		jQuery(this).click(function () {

			years_year.removeClass('active');
			jQuery(this).addClass('active');

			year_active = years.children('.active');
			year_active_text = year_active.children('.year__number').text();

			bton_dropdown_text.text(year_active_text);

			if (jQuery(window).width() < 576) {
				years.slideToggle();
			}

			showBoxs();

		});
	});

	jQuery(window).resize(function () {

		if (jQuery(window).width() >= 576) {
			years.css({ display: 'flex' });
		} else {

			if (icon.hasClass('icon-icon-chevron-up')) {
				years.css({ display: 'block' });
			} else {
				years.css({ display: 'none' });
			}

		}

	});


	function showBoxs() {
		
		const container_box = jQuery('.years-yela-body');
		const boxs = jQuery(`[data-yearsyela="link-year"]`);
	
		jQuery.each(boxs, function () {
	
			if (jQuery(this).hasClass('active')) {
	
				const box = jQuery(`${jQuery(this).attr('data-yearsyela-target')}`);
				container_box.children().removeClass('active');
				box.addClass('active');
	
			};
	
		});

	}

	

});